import { styled } from 'styled-components';

type Props = {
  $stacked?: boolean;
};

export const AvatarGroup = styled.div<Props>`
  display: flex;

  ${(props) =>
    props.$stacked
      ? `
      > *:not(:first-child) {
          margin-inline-start: -10px; 
        }
    `
      : undefined}
`;
